import * as EN from './translations/en.conf';
import * as DE from './translations/de.conf';
import * as CN from './translations/cn.conf';
import * as JP from './translations/jp.conf';
import * as ES from './translations/es.conf';
import * as RU from './translations/ru.conf';
import * as FR from './translations/fr.conf';

export const validTranslations = {
  en: EN,
  de: DE,
  es: ES,
  fr: FR,
  ru: RU,
  jp: JP,
  cn: CN,
};
